export default __webpack_public_path__ + "static/media/GOLDCOIN.a46ad690.svg";